import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import { LOAD_ADDRESS_SUCCESS, LoadJobsiteAddressComplete } from '../../../actions/jobsite-actions/jobsite.actions';
import { RenderMapAction } from '../../../actions/location-map-actions/location-map.actions';
import { CmxMapConfig } from '../../../../../../shared/models/cmx-map-config/cmx-map-config';
import { UnicEffectsAvailableEnum } from '@ordersnproducts/modules/shared/modules/dynamic-effects/deletable-effect-sources.constant';
import { EffectsRegistrationService } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effects-registration.service';

@Injectable()
export class JobsiteRenderMapEffects implements IEffect {
  /**
   * Render location map action
   * @type {Observable<RenderMapAction>}
   */

  PointOfDeliveryLoadAddressComplete$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_ADDRESS_SUCCESS),
      filter(() => this.isEffectAvailable()),
      switchMap((payload: LoadJobsiteAddressComplete) => {
        return of(new RenderMapAction(new CmxMapConfig(payload.payload)));
      }),
    ),
  );

  /**
   * Identifies if the effect is available to be executed
   * @returns {boolean}
   */
  private isEffectAvailable(): boolean {
    return this.effectRegister.isEffectAvailable(UnicEffectsAvailableEnum.JobsiteRenderMapEffects);
  }

  constructor(
    private actions$: Actions,
    private effectRegister: EffectsRegistrationService,
  ) {}
}
